import React from 'react';
import MapSec from '../components/mapSec';

const Maps = () => {
    return ( <>
    <MapSec />
    </> );
}
 
export default Maps;